<template>
	<v-snackbar
		top 
		right
		v-model	 = "snack_install"
		color 	 = "success"		
		:timeout = "time_install"		
		content-class = "pa-1"

	>
		<v-card  
			class = "pa-0 ma-0" 
			width = "100%"
		> <!-- 310 -->
			<v-card-title
				class  = "justify-center pa-1 caption"
			
			>	
				<v-spacer></v-spacer>
				<span
					v-text = "'Instalation progress'" 
				></span>
				<v-spacer></v-spacer>
				<v-btn 
			        x-small         
			        icon 
			        class  = "error"
			        @click = "snack_install = false"          			        
			    >
			        <v-icon 
			          x-small           
			          color  = "white" 
			          class  = "ma-0 pa-0" 
			        >mdi-close</v-icon>
			      </v-btn>
			</v-card-title>
			<v-divider></v-divider>
			<v-card-text 
				class = "d-flex justify-center"
			>
				<v-icon
					small
					class = "ml-2"
				>
					{{  icon_progress }}
				</v-icon>
				<v-progress-linear
					stream
					striped
					color 		  = "light-blue"
					height 		  = "15"
					:value 		  = "percent"
					:buffer-value = "percent"
				>
					<strong>
						{{ Math.ceil(percent) }}%
					</strong>
				</v-progress-linear>
			</v-card-text>
			<v-card-actions>
				{{ inf_install.progress}}
				<br>
				{{ inf_install.status }}
			</v-card-actions>
			
		</v-card>
	</v-snackbar>
</template>
<script>
	import EventBus from '@/event-bus'
	export default{
		name: 'installation_progress',
		data: () => ({
			snack_install : false,
			in_progress   : false,
			percent 	  : 0,
			time_install  : 1,
			icon_progress : 'mdi-download',
			inf_install   : {},
		}), // data
		methods: {
			actions(act, item, opt){
				if (act == 'close') {
					this.snack_install = false;
					localStorage.removeItem('installation_progress');
				}
			}, // actions
			get_local_progress(){
				let in_progress_local = false;
				if (localStorage.getItem('installation_progress')) {
					in_progress_local = JSON.parse(localStorage.getItem('installation_progress'));
				}
				this.in_progress = in_progress_local
			}, // get local progress
		},
		mounted(){
			/*				status: 'Downloading',
			  progressDetail: { current: 291623603, total: 711186701 },
			  progress: '[====================>                              ]  291.6MB/711.2MB',
			  id: '1bb195abf02b'
			}
			*/

			// rtsp://Admin:ebenezer890@193.178.3.37/stream2

			let vn = this;
			/*EventBus.$on('event_progress', (msg) =>{
				if (msg) {
					vn.snack_install = true;
					vn.time_install = -1;
					vn.inf_install = msg;
					

				}
			}); // EventBus */

			EventBus.$on('event_progress_image', (msg) => {
					console.log("Installation progress : ********** ", msg);

				if (msg) {
					/*	
						id
						progress
						progressDetail:{
							// bytes
							current: 32768
							total: 173641
						}
						status
					*/
					vn.snack_install = true;
					vn.time_install  = -1;
					vn.inf_install   = msg;

					vn.icon_progress = 'mdi-transfer-down'
					
					// installation of pull					
					let check_status  = msg.msj ? msg.msj : msg.status ? msg.status : msg;
					if (typeof check_status == 'string') {
						check_status 	  = check_status.toLowerCase();
					}

				
					// installation of get

					if ( check_status.includes('downloading')) { //msg.status
						if (msg.progressDetail) {
							let temp 		 = msg.progressDetail;
							let percent_temp = (((temp.current * 100) / temp.total)).toFixed(2);
							vn.percent  	 = percent_temp;
						}
						vn.percent 		 = 30;
						vn.inf_install = {
							status : check_status,
						}

					}

					if ( check_status.includes('pulling')) { // 'Pulling from jcaltamare/ebenezermotion'
						vn.icon_progress = 'mdi-chevron-down';
						vn.percent 		 = 50;
						vn.inf_install 	 = {
							status : check_status,
						}
					}
					if (check_status.includes('digest')) {
						vn.icon_progress = 'mdi-chevron-double-down';					
						vn.percent 		 = 65;
						vn.inf_install = {
							status : check_status,
						}
					}
					if ( check_status.includes('extracting')) {
						vn.icon_progress = 'mdi-folder-open';
						vn.percent 		 = 80;
						vn.inf_install = {
							status : check_status,
						}

					}

					if ( check_status.includes('up to date')) {
						vn.icon_progress = 'mdi-download';
						vn.percent 		 = 90;
						vn.inf_install = {
							status : check_status,
						}

					} 

					if ( check_status.includes('active')) {
						vn.time_install = 7500;					
						// EventBus.$emit('finish_installation_licence', true);
					}

					// for finish insallation

					if ((check_status || msg.code || msg.msj) && 
						(msg.code == 201 || (check_status).includes('finish'))) { // indexOf ('finished')
						/* 
							{code:201,image:'nameimage'} 
						*/
						vn.icon_progress = 'mdi-folder';
						vn.inf_install = {
							status : check_status,
						}
						vn.percent 		 = 100;						
						vn.time_install  = 7500;
						EventBus.$emit('finish_installation_licence', true);
						
						// vn.snack_install = true
					}
					

				}
			})

		},
		beforeDestroy(){
			// Limpiar EventBus listeners
			EventBus.$off('event_progress_image');
		}
	}; // export default
</script>